// Material Kit 2 React pages
import Contacto from "pages/Contacto";

export default function ContactoPage() {
  return <Contacto />;
}
